<script>
import i18n from "../i18n";
import appConfig from "@/app.config";
import { brand, isWhiteLabel } from "@/helpers/brand";
import SimpleBar  from "simplebar-vue";
import { required} from "vuelidate/lib/validators";

import {
  authMethods,
  commonMethods,
  projectMethods,
  userMethods,
} from "@/state/helpers";
import {
  clearProjectSession,
  consumeCompanySwitchedNotice,
  consumeStaleProjectNotice,
  forgetLastProject,
  getActiveCompany,
  getActiveCompanyId,
  getStoredUserId,
  markCompanySwitched,
  rememberCurrentProject,
  stampSessionCompany,
} from "@/helpers/companySession";

// A partir de cuántas cuentas el selector muestra el buscador.
const COMPANY_SEARCH_MIN = 7;

const PROJECT_LOAD_RETRY_DELAYS = [500, 1500];

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
       {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Español",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      currentUser:{},
      brand,
      // White-label: sin soporte por mail, Academy ni novedades de gopersonal
      // (el soporte es el chat de Calvin).
      isWhiteLabel,
      version: appConfig.version,
      selectedApp: null,
      apps: (getActiveCompany() || {}).products || {},
      projects:[],
      project:null,
      projectsLoading:false,
      projectsError:false,
      logoutLoading:false,
      companies:[],
      company:null,
      companySearch: '',
      sessionUserId: null,
      new_project:{},
      showModal: false,
      submitted:false,
      app:'',
      showProjectSelection: false,
      showSupportModal: false,
      supportEmail: 'soporte@gopersonal.com',
      isLocal: window.config.local
    };
  },
  validations: {
		new_project: {
			name: {
				required,
			},
		}
	},
  components: {
    SimpleBar
   },
   props: {
    logo: {
      type: String,
      default: '',
    },
    logo_small:{
      type: String,
      default: '',
    }
  },
  computed: {
    // Each tab works on its own account (see helpers/companySession), so
    // switching here never moves the other tabs.
    canSwitchCompany() {
      return this.companies.length > 1;
    },
    showCompanySearch() {
      return this.companies.length >= COMPANY_SEARCH_MIN;
    },
    filteredCompanies() {
      const q = this.companySearch.trim().toLowerCase();
      if (!q) {
        return this.companies;
      }
      return this.companies.filter((item) => (item.name || "").toLowerCase().includes(q));
    },
  },
  mounted() {
    this.currentUser = JSON.parse(localStorage.getItem("auth.currentUser"));
    this.sessionUserId = getStoredUserId();

    if (!this.notifyStaleProject()) {
      this.notifyCompanySwitched();
    }
    window.addEventListener("storage", this.onSessionStorageChange);

    this.loadCompanies();
    this.loadProjects();
    /*if(localStorage.getItem("app")){
      this.selectApp(localStorage.getItem("app"));
      this.app = localStorage.getItem("app");
    } else if (this.apps.personalization) {
      localStorage.setItem("app", 'personal');
      this.selectedApp = require("@/assets/images/go-personal.svg");
      this.app = 'personal'
    }else if (this.apps.live_shopping) {
      localStorage.setItem("app", 'live');
      this.app = 'live'
      this.selectedApp = require("@/assets/images/go-live-shop.svg");
    }*/
    localStorage.setItem("app", 'personal');
    //this.selectedApp = require("@/assets/images/go-personal.svg")

    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;

    if (!isWhiteLabel && !document.getElementById("canny-jssdk")) {
      const script = document.createElement("script");
      script.id = "canny-jssdk";
      script.type = "text/javascript";
      script.async = true;
      script.src = "https://canny.io/sdk.js";
      script.onload = () => {
        this.initCanny();
      };
      document.head.appendChild(script);
    } else if (!isWhiteLabel) {
      this.initCanny();
    }
  },
  watch: {
    // El navbar ya no se vuelve a montar al navegar: si el guard del router soltó
    // el proyecto en esta navegación, avisamos y pedimos elegir uno de nuevo.
    $route() {
      if (this.notifyStaleProject()) {
        this.loadProjects();
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.onSessionStorageChange);
  },
  methods: {
    ...authMethods,
    ...commonMethods,
    ...projectMethods,
    ...userMethods,

    /**
     * Each tab works on its own account, so another tab switching account does
     * not concern this one. What does is the session itself: when it is closed,
     * or opened by someone else, from another tab we get the `auth.currentUser`
     * storage event here and restart (the router guard sends the tab to the
     * login, or drops an account and project that are not of the new session).
     */
    onSessionStorageChange(event) {
      if (event.key && event.key !== "auth.currentUser") {
        return;
      }
      if (getStoredUserId() === this.sessionUserId) {
        return;
      }

      window.open("/", "_self");
    },

    // The router guard drops the account and project of a tab when they are not
    // part of the session any more; tell the user why their selection is gone.
    notifyStaleProject() {
      if (!consumeStaleProjectNotice()) {
        return false;
      }
      this.$notify({
        type: 'warning',
        text: this.$t("company.unavailable_here"),
        title: this.$t("company.title"),
      });
      return true;
    },

    // Switching account reloads the app; confirm where the tab landed.
    notifyCompanySwitched() {
      if (!consumeCompanySwitchedNotice()) {
        return;
      }
      const active = getActiveCompany();
      if (!active || !active.name) {
        return;
      }
      this.$notify({
        type: 'success',
        text: this.$t("company.switched_notice", { name: active.name }),
        title: this.$t("company.title"),
      });
    },

    isCurrentCompany(company) {
      return this.getCompanyId(company) === this.getCompanyId(this.company);
    },

    companyInitials(name) {
      const words = (name || "").trim().split(/\s+/).filter(Boolean);
      if (words.length === 0) {
        return "?";
      }
      if (words.length === 1) {
        return words[0].substring(0, 2).toUpperCase();
      }
      return (words[0][0] + words[1][0]).toUpperCase();
    },

    // Full-screen account picker, for the entry in the user menu and the
    // project picker (where the header may be covered by the modal).
    toSwitchCompany() {
      this.showProjectSelection = false;
      this.$router.push({ path: "/select-company", query: { from: "app" } }).catch(() => {});
    },

    getCompanyId(company) {
      if (!company) {
        return null;
      }
      return (company._id || company).toString();
    },

    syncDataForSalesSession(project) {
      const projectCompany = project?.company && typeof project.company === "object"
        ? project.company
        : null;
      const company = projectCompany || this.company;

      if (this.isDataForSalesCompany(company)) {
        sessionStorage.setItem("current_is_dfs", "true");
      } else {
        sessionStorage.removeItem("current_is_dfs");
      }
    },

    isDataForSalesCompany(company) {
      if (!company || typeof company !== "object") {
        return false;
      }
      return !!(
        company.isDataForSales
        || company.products?.dataForSales
        || company.products?.data_for_sales
      );
    },

    reloadAppMenu() {
      this.$parent?.reloadMenu?.();
    },

    applyCompanyState(companies, currentCompanyId) {
      if (currentCompanyId) {
        this.company = companies.find((item) => item._id === currentCompanyId) || this.company;
      }
      this.syncDataForSalesSession();
      this.reloadAppMenu();
    },

    syncProjectSessionStorage(project) {
      if (project?._id) {
        sessionStorage.setItem("current_project", project._id);

        if (project.advancedConfig?.currency) {
          sessionStorage.setItem("current_project_currency", JSON.stringify(project.advancedConfig.currency));
        } else {
          sessionStorage.setItem("current_project_currency", JSON.stringify({ code: 'USD', name: this.$t('settings.currency_us_dollar'), symbol: '$' }));
        }

        if (project.advancedConfig?.timezone) {
          sessionStorage.setItem("current_project_tz", project.advancedConfig.timezone);
        } else {
          sessionStorage.setItem("current_project_tz", 'UTC');
        }

        sessionStorage.setItem("current_project_site_url", (project.advancedConfig?.siteURL || '').trim());
        sessionStorage.setItem(`site_url_${project._id}`, (project.advancedConfig?.siteURL || '').trim());
      }

      this.syncDataForSalesSession(project);
      this.reloadAppMenu();
    },

    initCanny() {
      if (typeof Canny !== "undefined") {
        // eslint-disable-next-line no-undef
        Canny("initChangelog", {
          appID: "67c06c6da877dc6a33aa4320",
          position: "bottom",
          align: "right",
          theme: "light", // opciones: light [default], dark, auto
        });
      } else {
        // eslint-disable-next-line no-console
        console.error("Canny SDK no se ha cargado correctamente.");
      }
    },

    loadCompanies() {
      const stored = JSON.parse(localStorage.getItem("auth.currentUser") || "null");
      const user = stored?.user || {};
      const companies = [];
      const seen = {};

      const add = (company) => {
        const id = this.getCompanyId(company);
        if (!id || seen[id]) {
          return;
        }
        seen[id] = true;
        if (company && typeof company === "object" && company.name) {
          companies.push(company);
        } else {
          companies.push({ _id: id });
        }
      };

      add(user.company);
      (user.companies || []).forEach(add);

      this.companies = companies;
      // The account of THIS tab; `user.company` is only the last one chosen in any tab
      const currentCompanyId = getActiveCompanyId();
      this.company = companies.find((item) => item._id === currentCompanyId) || getActiveCompany();

      const missing = companies.filter((item) => !item.name);
      const fetchCurrentCompany = currentCompanyId
        ? this.getCompany(currentCompanyId)
          .then((data) => {
            const companyData = data?.data || data;
            if (!companyData) {
              return;
            }
            const index = companies.findIndex((item) => item._id === currentCompanyId);
            if (index >= 0) {
              Object.assign(companies[index], companyData);
            }
            this.company = companyData;
            if (getActiveCompanyId() === currentCompanyId) {
              // Keep the tab's copy of its account fresh (name, logo, products)
              stampSessionCompany(companyData);
            }
          })
          .catch(() => {})
        : Promise.resolve();

      const fetchMissingCompanies = missing.length
        ? Promise.all(
          missing.map((item) =>
            this.getCompany(item._id)
              .then((data) => {
                if (data?.data) {
                  Object.assign(item, data.data);
                } else if (data?.name) {
                  Object.assign(item, data);
                }
              })
              .catch(() => {})
          )
        )
        : Promise.resolve();

      Promise.all([fetchCurrentCompany, fetchMissingCompanies]).then(() => {
        this.companies = [...companies];
        this.applyCompanyState(companies, currentCompanyId);
      });
    },
    async loadProjects(){
      if (this.projectsLoading) {
        return;
      }

      const storedProjectId = sessionStorage.getItem("current_project");
      if (!storedProjectId) {
        this.showProjectSelection = true;
      }

      this.projectsLoading = true;
      this.projectsError = false;

      try {
        let projects;
        for (let attempt = 0; attempt <= PROJECT_LOAD_RETRY_DELAYS.length; attempt += 1) {
          try {
            projects = await this.getProjects();
            if (!Array.isArray(projects?.data)) {
              throw new Error("Invalid projects response");
            }
            break;
          } catch (error) {
            const status = error?.response?.status;
            const retryable = !status || status === 408 || status === 429;
            if (!retryable || attempt === PROJECT_LOAD_RETRY_DELAYS.length) {
              throw error;
            }
            await new Promise((resolve) => setTimeout(resolve, PROJECT_LOAD_RETRY_DELAYS[attempt]));
          }
        }

        this.projects = projects.data;
        if (storedProjectId) {
          this.project = this.projects.find((project) => project._id == storedProjectId) || null;

          if (!this.project) {
            // The stored id does not belong to the active company (the list is
            // company scoped): leaving it in sessionStorage would let every
            // screen keep reading and writing another company's project.
            // Forget it too, or the next tab would start on it again.
            forgetLastProject(storedProjectId);
            clearProjectSession();
            this.syncDataForSalesSession();
            this.reloadAppMenu();
            this.showProjectSelection = true;
            return;
          }

          this.syncProjectSessionStorage(this.project);
          // Keeps what a new tab starts with up to date (currency, timezone...)
          // without taking over the last choice made in another tab.
          rememberCurrentProject({ keepOther: true });
        } else {
          this.syncDataForSalesSession();
          this.reloadAppMenu();
          this.showProjectSelection = true;
        }
      } catch (error) {
        this.projectsError = true;
        if (!sessionStorage.getItem("current_project")) {
          this.showProjectSelection = true;
        }
        this.$notify({ type: 'error', text: this.$t("projects.get_projects_error"),title:  this.$t("projects.title") });
      } finally {
        this.projectsLoading = false;
      }
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
      localStorage.setItem('user_locale',locale);
      location.reload();
    },
    logoutUser() {
      if (this.logoutLoading) {
        return;
      }

      this.logoutLoading = true;
      this.logOut();
      this.$router.push({
        path: "/login",
      }).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error)
      });
    },
    toProfile(){
      this.$router.push({
          path: "/profile",
        }
      ).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error)
      });
    },
    toCompany() {
      this.$router.push({
          path: "/company",
        }
      ).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error)
      });
    },

    loadNews() {
      this.$refs.userDropdown?.hide();
      window.open('https://gopersonal.canny.io/changelog');
    },
    toHelp(){
      window.open('https://academy.gopersonal.ai')
    },
    toSupport(){
      this.showSupportModal = true;
    },
    copySupportEmail(){
      navigator.clipboard.writeText(this.supportEmail);
      this.$notify({
        type: 'success',
        text: this.$t('navbar.support_copy_success'),
        title: this.$t('common.help_center'),
      });
    },
    openSupportEmail(){
      window.location.href = `mailto:${this.supportEmail}`;
    },
    toApiReference(){
      window.open('https://docs.goshops.com/api-refernce')
    },
    toSettings(){
      this.$router.push({
          path: "/settings",
        }
      ).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error)
      });
    },
    toUsers(){
      this.$router.push({
          path: "/users",
        }
      ).catch((error) => {
        // eslint-disable-next-line no-console
        console.log(error)
      });
    },
    selectApp(app){
      switch(app) {
          case 'live':
            this.selectedApp = require("@/assets/images/go-live-shop.svg");
            break;
          case 'search':
            this.selectedApp = require("@/assets/images/go-search.svg");
            break;
          case 'reco':
            this.selectedApp = require("@/assets/images/go-reco.svg");
            break;
          case 'personal':
            this.selectedApp = require("@/assets/images/go-personal.svg");
            break;
        }
        //this.app = app;
        if(app!=localStorage.getItem("app")){
          localStorage.setItem("app", app);
          this.$parent.reloadMenu();
          //window.open("/","_self")
          let path='';
          if(app == 'personal'){
            path = '/personalizations'
          }else if(app== 'live'){
            path = '/metrics'
          }else if(app== 'reco'){
            path = '/reco-analyze'
          }else if(app== 'search'){
            path = '/search-analyze'
          }
          this.$router.push({
            path: path,
          })
          
        }
    },
    onSelectCompany(company) {
      const companyId = this.getCompanyId(company);
      if (!companyId || companyId === this.getCompanyId(this.company)) {
        return;
      }

      let loader = this.$loading.show();
      this.selectCompany(companyId).then((selectedCompany) => {
        // The action already dropped the project and filters of the company we left
        this.company = selectedCompany || company;
        if (this.isDataForSalesCompany(this.company)) {
          sessionStorage.setItem("current_is_dfs", "true");
        } else {
          sessionStorage.removeItem("current_is_dfs");
        }
        this.currentUser = JSON.parse(localStorage.getItem("auth.currentUser"));
        this.project = null;
        this.reloadAppMenu();
        markCompanySwitched();
        window.open("/", "_self");
      }).catch(() => {
        this.$notify({
          type: 'error',
          text: this.$t("company.select_error"),
          title: this.$t("company.title"),
        });
      }).finally(() => {
        loader.hide();
      });
    },
    onSelectProject(project){
      // Picking the first project of the tab keeps the screen that was asked
      // for; changing project goes home, where nothing belongs to the old one.
      const firstProject = !this.project;

      this.showProjectSelection = false;
      this.syncProjectSessionStorage(project);
      this.project = project;
      // New tabs of this account start on this project (see helpers/companySession)
      rememberCurrentProject();

      if (firstProject) {
        window.location.reload();
        return;
      }
      window.open("/","_self")
    },
    onNewProjectClicked(){
      this.showModal = true;
    },
    onCancelCreateClicked(){
      this.showModal = false;
      this.new_project ={};
      this.submitted = false;
		},
    onConfirmNewProjectClicked(){
      this.submitted = true;
			this.$v.$touch();

			if (this.$v.$invalid) {
				return;
			}

      this.new_project.advancedConfig = {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
      let loader = this.$loading.show();
			this.createProject(this.new_project).then((response)=>{
				this.$notify({ type: 'success', text: this.$t('projects.create_project_success'),title: this.$t('projects.title') });
				this.showModal = false;
        this.new_project = {};
        this.submitted = false;

        const createdProject = response?.data;
        if (this.showProjectSelection && createdProject?._id) {
          this.onSelectProject(createdProject);
          return;
        }

        this.loadProjects();
				
			}).catch((()=>{
        this.$notify({ type: 'error', text: this.$t('projects.create_project_error'),title: this.$t('projects.title') });
			})).finally(()=>{
				loader.hide();
			});
      
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img v-if="brand.navIcon" class="brand-icon" :src="brand.navIcon" :alt="brand.title" height="24" />
              <img v-else src="@/assets/images/logo.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="17" />
            </span>
          </router-link>

          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img v-if="brand.navIcon" class="brand-icon" :src="brand.navIcon" :alt="brand.title" height="24" />
              <img v-else src="@/assets/images/go_shops_small.svg" alt height="22" />
            </span>
            <span class="logo-lg">
              <img v-if="brand.navLogo" :src="brand.navLogo" :alt="brand.title" :style="brand.navLogoStyle" height="30" />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu">
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <div style="margin: auto; text-align: center; visibility: hidden !important;" v-if="currentUser && currentUser.user?.role == 'admin'">
          <div class="d-none d-lg-inline-block noti-icon">
            <img :src=selectedApp height="30px" class="me-2"/>
            <img v-if="app!='personal'" style="opacity: 0.3;" class="me-2 interact" src="https://go-shops.nyc3.digitaloceanspaces.com/uploads/2023/10/81dc16ff-6432-4b8e-ab07-055fbf1bacd6.svg" height="30px" v-on:click="selectApp('personal')"/>
            <img v-if="app!='live'" style="opacity: 0.3;" class="me-2 interact" src="https://go-live.fra1.digitaloceanspaces.com/uploads/2023/09/6924e456-be9e-455f-8ddf-3f66f1fa66c5.svg" height="30px" v-on:click="selectApp('live')"/>
            <img v-if="app!='reco'" style="opacity: 0.3;" class="me-2 interact" src="https://go-live.fra1.digitaloceanspaces.com/uploads/2023/09/ad889703-e61f-4cfb-a185-38266097d353.svg" height="30px" v-on:click="selectApp('reco')"/>
            <img v-if="app!='search'" style="opacity: 0.3;" class="me-2 interact" src="https://go-live.fra1.digitaloceanspaces.com/uploads/2023/09/0ecc96a7-3b5f-4b09-9d22-2d344301815e.svg" height="30px" v-on:click="selectApp('search')"/>
          </div>
          <!--<b-dropdown ref="appsDropdown" class="d-none d-lg-inline-block noti-icon" menu-class="dropdown-menu-lg dropdown-menu-end" right
          toggle-class="header-item" variant="black">
          <template v-slot:button-content>
            <img :src=selectedApp height="30px" class="me-2"/>
            <img style="opacity: 0.3;" class="me-2" src="https://go-live.fra1.digitaloceanspaces.com/uploads/2023/09/08e9aff6-8fb6-41ea-af43-21390cbe14d2.svg" height="30px"/>
            <img style="opacity: 0.3;" class="me-2" src="https://go-live.fra1.digitaloceanspaces.com/uploads/2023/09/6924e456-be9e-455f-8ddf-3f66f1fa66c5.svg" height="30px"/>
            <img style="opacity: 0.3;" class="me-2" src="https://go-live.fra1.digitaloceanspaces.com/uploads/2023/09/ad889703-e61f-4cfb-a185-38266097d353.svg" height="30px"/>
            <img style="opacity: 0.3;" class="me-2" src="https://go-live.fra1.digitaloceanspaces.com/uploads/2023/09/0ecc96a7-3b5f-4b09-9d22-2d344301815e.svg" height="30px"/>
          </template>

          <div class="px-lg-2">
            <div class="row no-gutters interact" v-if="apps.personalization">
              <div class="col">
                <a class="dropdown-icon-item" v-on:click="selectApp('personal')">
                  <img :src="require('@/assets/images/go-personal.svg')"/>
                  <span>{{$t("navbar.personalization")}}</span>
                </a>
              </div>
            </div>
            <div class="row ni-gutters interact" v-if="apps.live_shopping">
              <div class="col">
                <a class="dropdown-icon-item" v-on:click="selectApp('live')">
                  <img :src="require('@/assets/images/go-live-shop.svg')"/>
                  <span>{{$t("navbar.live_shopping")}}</span>
                </a>
              </div>
            </div>
            <div class="row no-gutters interact" v-if="apps.recommendation">
              <div class="col">
                <a class="dropdown-icon-item" v-on:click="selectApp('reco')">
                  <img :src="require('@/assets/images/go-reco.svg')"/>
                  <span>{{$t("navbar.recommendation")}}</span>
                </a>
              </div>
            </div>
            <div class="row no-gutters interact" v-if="apps.search">
              <div class="col">
                <a class="dropdown-icon-item" v-on:click="selectApp('search')">
                  <img :src="require('@/assets/images/go-search.svg')"/>
                  <span>{{$t("navbar.search")}}</span>
                </a>
              </div>
            </div>
          </div>
        </b-dropdown>-->
        </div>
      </div>

      <div class="d-flex">
        <b-dropdown variant="white" right toggle-class="header-item" v-if="currentUser.user && currentUser.user.role =='host'">
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            <!--{{ text }} -->
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: lan === entry.language }">
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="me-1"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <b-modal
          v-model="showModal"
          :title="$t('projects.new_project')"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer>
            <form @submit.prevent="onConfirmNewProjectClicked">
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="name">{{$t('projects.new_project_name')}}*</label>
                    <input
                      id="name"
                      v-model="new_project.name"
                      type="text"
                      class="form-control"
                      :placeholder="$t('projects.new_project_name_placeholder')"
                      :class="{'is-invalid':submitted && $v.new_project.name.$error}"
                    />
                      <div v-if="submitted && !$v.new_project.name.required" class="invalid-feedback">
                        {{$t('projects.new_project_name_required')}}
                      </div>
                  </div>
                </div>
              </div>
              <div class="text-end pt-5 mt-3">
                  <b-button variant="light" @click="onCancelCreateClicked">{{$t('common.cancel')}}</b-button>
                  <b-button type="submit" variant="primary" class="ms-1"
                  >{{$t('common.confirm')}}</b-button>
              </div>
            </form>
        </b-modal>
        <b-modal
          v-model="showSupportModal"
          id="modal-center"
          centered
          :title="$t('common.help_center')"
          title-class="font-18"
          hide-footer
        >
          <p>{{ $t('navbar.support_message') }}</p>
          <b-input-group>
            <b-form-input :value="supportEmail" type="text" readonly />
            <b-input-group-append>
              <b-button variant="primary" @click="copySupportEmail" v-b-popover.hover.bottom="$t('navbar.support_copy_email')">
                <i class="bx bx-copy"></i>
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <div class="text-end pt-3 mt-3">
            <b-button variant="light" @click="showSupportModal = false">{{ $t('common.cancel') }}</b-button>
            <b-button variant="primary" class="ms-1" @click="openSupportEmail">
              <i class="bx bx-envelope me-1"></i>{{ $t('navbar.support_open_email') }}
            </b-button>
          </div>
        </b-modal>
        <div v-if="!isWhiteLabel" class="dropdown d-none d-lg-inline-block">
          <button type="button" class="btn header-item noti-icon p-0" @click="toSupport" v-b-popover.hover.bottom="$t('common.help_center')">
            <i class="bx bx-message-square-dots"></i>
          </button>
        </div>

        <div v-if="!isWhiteLabel" class="dropdown d-none d-lg-inline-block ms-2">
          <button type="button" class="btn header-item noti-icon p-0" @click="toHelp" v-b-popover.hover.bottom="$t('common.academy')">
            <i class="bx bx-book"></i>
          </button>
        </div>
        
        <div v-if="!isWhiteLabel" class="dropdown d-none d-lg-inline-block ms-2 me-2">
          <button
            ref="cannyChangelogBtn"
            data-canny-changelog
            type="button"
            class="btn header-item noti-icon p-0"
            v-b-popover.hover.bottom="$t('navbar.news')"
          >
            <i class="bx bxs-megaphone"></i>
          </button>
        </div>
        <div
          v-if="!canSwitchCompany"
          class="header-item border-left d-inline-flex align-items-center px-3"
        >
          <i class="bx bx-buildings"></i>
          <span class="ms-1">{{ company?.name }}</span>
        </div>
        <b-dropdown
          v-else
          variant="black"
          toggle-class="header-item border-left"
          menu-class="dropdown-menu-lg dropdown-menu-end company-switcher"
          right
          @hidden="companySearch = ''"
        >
          <template v-slot:button-content>
            <span :title="$t('company.switch_title')">
              <i class="bx bx-buildings"></i>
              {{ company?.name }}
              <i class="mdi mdi-chevron-down"></i>
            </span>
          </template>

          <div class="company-switcher__head">
            <h6 class="m-0">{{ $t('company.switch_title') }}</h6>
            <p class="small text-muted mb-0 mt-1">{{ $t('company.switch_hint') }}</p>
            <input
              v-if="showCompanySearch"
              v-model="companySearch"
              type="text"
              class="form-control form-control-sm mt-2"
              :placeholder="$t('company.search_placeholder')"
            />
          </div>
          <b-dropdown-divider class="user-menu-divider"></b-dropdown-divider>
          <SimpleBar style="max-height: 280px;">
            <b-dropdown-item
              v-for="item in filteredCompanies"
              :key="item._id"
              :link-class="['company-switcher__item', { 'is-current': isCurrentCompany(item) }]"
              @click="onSelectCompany(item)"
            >
              <span class="company-switcher__avatar">
                <img v-if="item.logo" :src="item.logo" alt />
                <template v-else>{{ companyInitials(item.name) }}</template>
              </span>
              <span class="company-switcher__name">{{ item?.name }}</span>
              <span v-if="isCurrentCompany(item)" class="badge badge-soft-primary font-size-12">
                <i class="bx bx-check"></i> {{ $t('company.current') }}
              </span>
            </b-dropdown-item>
            <p v-if="filteredCompanies.length === 0" class="small text-muted text-center my-3">
              {{ $t('company.empty') }}
            </p>
          </SimpleBar>
        </b-dropdown>
        <b-dropdown variant="black" toggle-class="header-item border-left" menu-class="dropdown-menu-lg dropdown-menu-end " right>
          <template v-slot:button-content>
            <i class="bx bx-box"></i>
            {{project?.name}}
            <i class="mdi mdi-chevron-down"></i>
          </template>

          <div class="p-2">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  {{this.$t('projects.title')}}
                </h6>
              </div>
              <div class="small">
                {{this.$t('projects.subtitle')}}
              </div>
            </div>
          </div>
          <b-dropdown-divider></b-dropdown-divider>
          <SimpleBar style="max-height: 230px;">
            <div v-for="project in projects" :key="project._id" v-on:click="onSelectProject(project)">
              <b-dropdown-item class="d-block">
                {{ project?.name }}  
              </b-dropdown-item>
              <b-dropdown-divider></b-dropdown-divider>
            </div>
          </SimpleBar>
          <div class="p-2 border-top d-grid" v-on:click="onNewProjectClicked">
            <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
              <i class="mdi mdi-arrow-right-circle me-1"></i>
              {{this.$t('projects.new_project')}}
            </a>
          </div>
        </b-dropdown>
        <b-dropdown
          ref="userDropdown"
          right
          variant="black"
          toggle-class="header-item border-left"
          menu-class="dropdown-menu-lg dropdown-menu-end user-account-dropdown"
        >
          <template v-slot:button-content>
            <div class="header-image-text">
              <div class="avatar-xs header-profile-user header-profile-user-color" v-if="!currentUser.user || !currentUser.user.imageURL">
                  <span class="avatar-title rounded-circle header-profile-user">{{ currentUser.user != null? currentUser.user.name.charAt(0) : ""}}</span>
              </div>
              <img
                class="rounded-circle header-profile-user"
                :src="currentUser.user.imageURL"
                alt="Header Avatar"
                v-if="currentUser.user && currentUser.user.imageURL"
              />
              <span class="d-none d-xl-inline-block ms-1">{{
                currentUser.user != null? currentUser.user.name : ""
              }}</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block ms-1"></i>
            </div>
          </template>

          <div class="user-menu-header">
            <div class="d-flex align-items-center">
              <div class="avatar-sm flex-shrink-0" v-if="!currentUser.user || !currentUser.user.imageURL">
                <span class="avatar-title rounded-circle bg-primary text-white font-size-16">
                  {{ currentUser.user != null ? currentUser.user.name.charAt(0) : "" }}
                </span>
              </div>
              <img
                v-else
                class="rounded-circle avatar-sm flex-shrink-0"
                :src="currentUser.user.imageURL"
                alt="User Avatar"
              />
              <div class="ms-2 overflow-hidden">
                <h6 class="mb-0 text-truncate">{{ currentUser.user != null ? currentUser.user.name : "" }}</h6>
                <small class="text-muted text-truncate d-block">{{ currentUser.user != null ? currentUser.user.email : "" }}</small>
              </div>
            </div>
          </div>

          <template v-if="canSwitchCompany">
            <b-dropdown-divider class="user-menu-divider"></b-dropdown-divider>
            <b-dropdown-item @click="toSwitchCompany()" link-class="user-menu-link">
              <span class="user-menu-icon"><i class="bx bx-transfer"></i></span>
              <span class="overflow-hidden">
                <span class="d-block">{{ $t("company.switch_title") }}</span>
                <small class="text-muted text-truncate d-block">{{ company?.name }}</small>
              </span>
            </b-dropdown-item>
          </template>

          <template v-if="currentUser.user && currentUser.user.role == 'host'">
            <b-dropdown-divider class="user-menu-divider"></b-dropdown-divider>
            <b-dropdown-item @click="toProfile()" link-class="user-menu-link">
              <span class="user-menu-icon"><i class="bx bx-user"></i></span>
              <span>{{ $t("navbar.profile") }}</span>
            </b-dropdown-item>
          </template>
          <template v-else>
            <b-dropdown-divider class="user-menu-divider"></b-dropdown-divider>
            <b-dropdown-item @click="toSettings()" link-class="user-menu-link">
              <span class="user-menu-icon"><i class="bx bx-cog"></i></span>
              <span>{{ $t("navbar.settings") }}</span>
            </b-dropdown-item>
            <b-dropdown-divider class="user-menu-divider"></b-dropdown-divider>
            <b-dropdown-item @click="toUsers()" link-class="user-menu-link">
              <span class="user-menu-icon"><i class="bx bx-group"></i></span>
              <span>{{ $t("users.title") }}</span>
            </b-dropdown-item>
          </template>

          <b-dropdown-divider class="user-menu-divider"></b-dropdown-divider>

          <template v-if="!isWhiteLabel">
            <b-dropdown-item @click="loadNews" link-class="user-menu-link">
              <span class="user-menu-icon"><i class="bx bx-star"></i></span>
              <span>{{ $t("navbar.news") }}</span>
            </b-dropdown-item>

            <b-dropdown-divider class="user-menu-divider"></b-dropdown-divider>
          </template>

          <div class="user-menu-version">
            <small class="text-muted">{{ $t('common.version') }}{{ version }}</small>
          </div>

          <b-dropdown-divider class="user-menu-divider"></b-dropdown-divider>

          <b-dropdown-item @click="logoutUser()" link-class="user-menu-link">
            <span class="user-menu-icon"><i class="bx bx-power-off text-danger"></i></span>
            <span>{{ $t("navbar.logout") }}</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <b-modal v-model="showProjectSelection" centered :no-close-on-backdrop="true" :no-close-on-esc="true" :title="$t('projects.title')" title-class="font-18" hide-footer :hide-header-close="true">
      <div class="d-inline-flex w-100">
        <i class="bx bx-box"></i>
          <p class="small ms-1">
            {{this.$t('projects.subtitle')}}
          </p>
      </div>
      <div v-if="company && company.name" class="d-flex align-items-center justify-content-between small">
        <span class="text-muted text-truncate">
          <i class="bx bx-buildings"></i>
          {{ $t('company.working_on') }}: <strong>{{ company.name }}</strong>
        </span>
        <a v-if="canSwitchCompany" class="flex-shrink-0 ms-2" href="javascript:void(0)" @click="toSwitchCompany">
          {{ $t('company.switch_title') }}
        </a>
      </div>

      <hr/>
      <div v-if="projectsLoading" class="text-center text-muted py-4" role="status">
        <b-spinner small variant="primary" class="me-2"></b-spinner>
        <span class="small">{{ $t('projects.loading') }}</span>
      </div>
      <div v-else-if="projectsError" class="text-center py-3">
        <p class="small text-danger mb-3">{{ $t('projects.load_error_help') }}</p>
        <b-button size="sm" variant="primary" @click="loadProjects">
          {{ $t('projects.retry') }}
        </b-button>
      </div>
      <div v-else-if="projects.length === 0" class="text-center text-muted py-3">
        <p class="mb-0 small">{{ $t('projects.empty_list') }}</p>
      </div>
      <template v-else>
        <div class="interact" v-for="project in projects" :key="project._id" v-on:click="onSelectProject(project)">
          <div class="d-inline-flex w-100">
            <a class="dropdown-item"> {{project.name}} </a>
            <i class="bx bx-chevron-right font-size-20"></i>
          </div>
          <hr/>
        </div>
      </template>
      <div v-if="!projectsLoading && !projectsError" class="p-2 border-top d-grid" v-on:click="onNewProjectClicked">
        <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
          <i class="mdi mdi-arrow-right-circle me-1"></i>
          {{ $t('projects.new_project') }}
        </a>
      </div>
      <div v-if="!projectsLoading && (projectsError || projects.length === 0)" class="px-2 pt-2 border-top d-grid">
        <b-button size="sm" variant="outline-danger" :disabled="logoutLoading" @click="logoutUser">
          <b-spinner v-if="logoutLoading" small class="me-1"></b-spinner>
          {{ $t('navbar.logout') }}
        </b-button>
      </div>
          
    </b-modal>
  </header>
</template>
<style>
.header-image-text {
  display: inline-flex;
  align-items: center;
} 

.header-profile-user-color {
  background: #ffffff;
}

.interact{
    cursor: pointer;
}

.dropdown-toggle {
    padding-top: 5px !important;
}

.header-item.border-left,
.header-item.border-left:hover,
.header-item.border-left:focus,
.header-item.border-left.show {
  border: 0 !important;
  border-left: 1px solid lightgray !important;
}

.Canny_Badge{
  top: 5px !important;
}

.user-account-dropdown {
  padding: 0;
}

.user-account-dropdown > li {
  margin: 0;
}

.user-menu-header {
  padding: 0.65rem 1rem;
}

.user-menu-divider {
  margin: 0 !important;
}

.user-menu-link {
  display: flex !important;
  align-items: center !important;
  gap: 0.5rem;
  padding: 0.45rem 1rem !important;
  line-height: 1.25;
}

.user-menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  font-size: 16px;
  line-height: 1;
}

.user-menu-version {
  padding: 0.4rem 1rem 0.4rem 2.35rem;
}

.company-switcher {
  padding: 0;
  min-width: 300px;
}

.company-switcher > li {
  margin: 0;
}

.company-switcher__head {
  padding: 0.75rem 1rem;
}

.company-switcher__item {
  display: flex !important;
  align-items: center !important;
  gap: 0.6rem;
  padding: 0.5rem 1rem !important;
}

.company-switcher__item.is-current {
  cursor: default;
  background: rgba(94, 64, 191, 0.06);
}

.company-switcher__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  overflow: hidden;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  background: #5e40bf;
}

.company-switcher__avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #ffffff;
}

.company-switcher__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>
